import { type Dayjs } from 'dayjs';

import {
  EDateRangePreset,
  getDateRangeDays,
  getQuarterStart,
  type IDateRange,
  QUARTER_DATE_RANGE_PRESETS,
  type TDateRangePreset,
} from './date-range';

const MONTHS_IN_QUARTER = 3;

export const OSS_DATE_RANGE_PRESETS: readonly TDateRangePreset[] = [
  EDateRangePreset.THIS_MONTH,
  EDateRangePreset.LAST_MONTH,
  EDateRangePreset.THIS_QUARTER,
  EDateRangePreset.LAST_QUARTER,
  ...QUARTER_DATE_RANGE_PRESETS,
  EDateRangePreset.THIS_YEAR,
  EDateRangePreset.LAST_YEAR,
];

export const isCurrentQuarter = (range: IDateRange, now: Dayjs): boolean => {
  const quarterStart: Dayjs = getQuarterStart(now);

  return (
    range.from.isSame(quarterStart) &&
    range.to.isSame(quarterStart.add(MONTHS_IN_QUARTER, 'month'))
  );
};

export const getOssFilingDeadline = (range: IDateRange): Dayjs =>
  range.to.endOf('month');

export const getQuarterForecast = (
  vatSoFar: number,
  quarter: IDateRange,
  now: Dayjs,
): number | null => {
  const totalDays: number = getDateRangeDays(quarter);
  const elapsedDays: number = Math.min(
    totalDays,
    getDateRangeDays({ from: quarter.from, to: now.startOf('day') }) + 1,
  );

  if (elapsedDays <= 0) {
    return null;
  }

  return (vatSoFar / elapsedDays) * totalDays;
};
